import { render, staticRenderFns } from "./SystemBackup.vue?vue&type=template&id=14a7e899&scoped=true"
import script from "./SystemBackup.vue?vue&type=script&lang=js"
export * from "./SystemBackup.vue?vue&type=script&lang=js"
import style0 from "./SystemBackup.vue?vue&type=style&index=0&id=14a7e899&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a7e899",
  null
  
)

export default component.exports